import ButtonPrimary from "../Common/Buttons/ButtonPrimary";
import { globalStores } from "../api/globalStores";
import toast from "react-hot-toast";
import { observer } from "mobx-react";
import { useNavigate } from "react-router-dom";

export const ReferralGetter = observer(() => {
  const navigate = useNavigate();
  const showReferralCode = () => {
    toast.success(
      <div className="flex">
        <span>
          Your referral code is (Click to Copy)
          <br />
          <span
            className="whitespace-nowrap underline cursor-pointer"
            onClick={() => {
              navigator.clipboard.writeText(
                globalStores.parentStore.getReferralCode()
              );
              toast.success("Copied to clipboard");
            }}
          >
            {globalStores.parentStore.getReferralCode()}
          </span>
        </span>
      </div>,
      { duration: 10000 }
    );
  };

  return (
    <>
      <p className="text-xlarge pl-3 text-center w-full">
        Thanks for signing {globalStores.childStore.userDetail.firstName} up{" "}
        {globalStores.parentStore.userDetail.firstName}!
      </p>
      <p className="text-large pb-4 pl-3 text-center w-full">
      We're all about learning the Social Way; we've sent your referral code to your email. <br/><br/>
      Invite some friends to join you and they will enjoy a discount off on us!
      </p>
      <div className="flex flex-col md:flex-row lg:flex-col gap-2">
        {/* <div className="lg:w-full md:w-1/2 w-full">
          <ButtonPrimary onClick={showReferralCode}>
            Get My Referral Code
          </ButtonPrimary>
        </div> */}
        <div className="lg:w-full md:w-1/2 w-full">
          <ButtonPrimary onClick={() => navigate("/parent/dashboard")}>
            Proceed to Dashboard
          </ButtonPrimary>
        </div>
        {/* <div className="flex justify-center py-4 px-2">
          <button
            onClick={() => navigate("/parent/flow/child_avatar_details")}
            className="text-brij-DarkGrey hover:text-brij-Black"
          >
            BACK
          </button>
        </div> */}
      </div>
    </>
  );
});
